import springAvirtualApi from '../../services/springAvirtualApi'

export const login = data => (
	new Promise((resolve, reject) => {
		springAvirtualApi()
			.post('/auth/login', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const logout = () => (
	new Promise((resolve, reject) => {
		springAvirtualApi()
			.post('/auth/logout')
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)